@use '@design/design-tokens/typography/typography' as *;

.headerTitle {
  @include typography-v2-body-xs;
  color: var(--text-default);

  &.read {
    color: var(--text-soft);
  }
}

.title {
  @include typography-v2-body-sm;
  color: var(--text-default);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.read {
    color: var(--text-soft);
  }
}

.subtitle {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
